// 2P AI — elenco tag editabile (aree protette, cartelle consentite). Aggiunta via prompt.
import { Icon } from './Icon';
import { onCardKey } from '../lib/a11y';

export function TagList({ items, onAdd, onRemove, addLabel = 'Aggiungi', promptText }: {
  items: string[];
  onAdd: (v: string) => void;
  onRemove: (v: string) => void;
  addLabel?: string;
  promptText: string;
}) {
  function add() {
    const v = window.prompt(promptText);
    if (v && v.trim()) onAdd(v.trim());
  }
  return (
    <div className="taglist">
      {items.map((it) => (
        <span className="tagk" key={it}>
          {it}
          <span className="x" role="button" tabIndex={0} aria-label={`Rimuovi ${it}`} onClick={() => onRemove(it)} onKeyDown={onCardKey(() => onRemove(it))}><Icon name="close" /></span>
        </span>
      ))}
      <span className="tagk add" role="button" tabIndex={0} onClick={add} onKeyDown={onCardKey(add)}>
        <Icon name="add" />{addLabel}
      </span>
    </div>
  );
}
